import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, Tooltip, IconButton

} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import MaterialTable from "material-table";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useAlert } from "react-alert";
import DateFnsUtils from '@date-io/date-fns';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { LoadingComponent } from 'src/utils/newLoader';
import PaymentVoucherPDF from './PaymentVoucherPDF';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const screenCode = 'ADVANCEDPAYMENTDETAILSMG';

export default function AdvancePaymentDetailsMG(props) {
  const title = "Remove Advance Payment"
  const classes = useStyles();
  const [advancedPaymentList, setAdvancedPaymentList] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    statusID: 0,
    advanceRequestType: 0,
  });

  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [routes, setRoutes] = useState();
  const [advancePaymentData, setAdvancePaymentData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const componentRef = useRef([]);
  const [fromDate, handleFromDate] = useState(new Date());
  const [toDate, handleToDate] = useState(new Date());
  const alert = useAlert();
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "",
    factoryName: "",
    routeName: '',
    statusID: '',
    advanceRequestType: '',
    startDate: '',
    endDate: ''
  });

  const [page, setPage] = useState(0);
  const [hiddenTable, setHiddenTable] = useState(true);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(
    false
  );
  const [deletingRow, setDeletingRow] = React.useState(null);
  const [state, setState] = useState([]);

  const handleDeleteConfirmationClose = () => {
    setDeletingRow(null);
    setDeleteConfirmationOpen(false);
  };

  let encryptedReqID = "";
  let encryptedIssuingDate = "";
  let encryptedRouteName = "";

  const handleClickView = (advancePaymentRequestID, issuingDate, routeName) => {
    encryptedReqID = btoa(advancePaymentRequestID.toString());
    encryptedIssuingDate = btoa(issuingDate.toString());
    encryptedRouteName = btoa(routeName.toString());

    let modelID = {
      groupID: parseInt(advancedPaymentList.groupID),
      factoryID: parseInt(advancedPaymentList.factoryID),
      routeID: parseInt(advancedPaymentList.routeID),
      statusID: parseInt(advancedPaymentList.statusID),
      advanceRequestType: parseInt(advancedPaymentList.advanceRequestType),
      fromDate: fromDate,
      toDate: toDate,
      advancePaymentData: advancePaymentData,
      page: page,
      factoryName: selectedSearchValues.factoryName,
      groupName: selectedSearchValues.groupName,
      routeName: selectedSearchValues.routeName,
    };
    sessionStorage.setItem(
      'ADP-listing-page-search-parameters-id',
      JSON.stringify(modelID)
    );

    navigate('/app/advancePaymentDetailsMG/ViewAdvancePaymentDetailsMG/' + encryptedReqID + "/" + encryptedIssuingDate + "/" + encryptedRouteName);
  }

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('ADP-listing-page-search-parameters-id')
    );
    getPermission(IDdata);
    if (IDdata != null) {
      getSelectedDropdownValuesForReport(IDdata)
    }
  }, []);

  useEffect(() => {
    sessionStorage.removeItem(
      'ADP-listing-page-search-parameters-id'
    );
  }, []);

  useEffect(() => {
    if (IDDataForDefaultLoad != null) {
      GetDetails();
      getSelectedDropdownValuesForReport(selectedSearchValues)
    }
  }, [IDDataForDefaultLoad]);


  useEffect(() => {
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [advancedPaymentList.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [advancedPaymentList.factoryID]);

  async function getPermission(IDdata) {

    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADVANCEPAYMENTDETAILSMG');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const isInitialLoad = IDdata === null
    if (isInitialLoad) {
      setAdvancedPaymentList({
        ...advancedPaymentList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      });
    } else {
      setAdvancedPaymentList({
        ...advancedPaymentList,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID,
        routeID: IDdata.routeID,
        statusID: IDdata.statusID,
        advanceRequestType: IDdata.advanceRequestType,
      });
      handleFromDate(IDdata.fromDate);
      handleToDate(IDdata.toDate);
      setAdvancePaymentData(IDdata.advancePaymentData);
      setPage(IDdata.page);
      setHiddenTable(false);
      setIsIDDataForDefaultLoad(IDdata);
    }
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(advancedPaymentList.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(advancedPaymentList.factoryID);
    setRoutes(routeList);
  }

  async function GetDetails() {

    let model = {
      groupID: parseInt(advancedPaymentList.groupID),
      factoryID: parseInt(advancedPaymentList.factoryID),
      startDate: fromDate,
      endDate: toDate,
      routeID: parseInt(advancedPaymentList.routeID),
      advanceRequestType: parseInt(advancedPaymentList.advanceRequestType),
      statusID: parseInt(advancedPaymentList.statusID),
    }

    if (IDDataForDefaultLoad == null) {
      getSelectedDropdownValuesForReport(model);
    }
    setIsIDDataForDefaultLoad(null)

    const response = await services.GetAdvancePaymentDetailsForView(model);
    if (response.statusCode == "Success" && response.data != null) {
      response.data.forEach((x, i) => {
        x.index = i
        let totalDebit = 0
        let totalCredit = 0
        x.voucherDetails.forEach(y => {
          totalDebit += y.debit
          x.totalDebit = totalDebit
          totalCredit += y.credit
          x.totalCredit = totalCredit
          y.index = i
        })
      });
      setAdvancePaymentData(response.data);
      createDataForExcel(response.data);
      setHiddenTable(false);
      if (response.data.length == 0) {
        alert.error("No records to display");
        setHiddenTable(true);
      }
    }
    else {
      alert.error("Error");
    }
  }

  async function DeleteAdvancePaymentDetail() {
    const response = await services.DeleteAdvancePayment(deletingRow);

    if (response.statusCode == 'Success') {
      alert.success(response.message);
      setAdvancePaymentData((prevData) =>
        prevData.filter(row => row.advancePaymentRequestID !== deletingRow.advancePaymentRequestID)
      );
      setDeletingRow(null);
    } else {
      alert.error(response.message);
    }
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(fromDate.toString()).format().split('T')[0];
    var endDate = moment(toDate.toString()).format().split('T')[0];
    // Check if the FactoryList or GroupList arrays are empty
    if (FactoryList.length < 1 || GroupList.length < 1) {
      setSelectedSearchValues({
        ...selectedSearchValues,
        factoryName: searchForm.factoryName,  // Use values from the search form if lists are empty
        groupName: searchForm.groupName,
        routeName: searchForm.routeName || 'All Routes',
        statusID: searchForm.statusID || '',
        advanceRequestType: searchForm.advanceRequestType || '',
        startDate: startDate,
        endDate: endDate,
      });
    } else {
      setSelectedSearchValues({
        ...selectedSearchValues,
        factoryName: FactoryList[searchForm.factoryID] || 'All Factories',  // Use FactoryList if available
        groupName: GroupList[searchForm.groupID] || 'All Groups',
        routeName: routes && routes[searchForm.routeID] ? routes[searchForm.routeID] : 'All Routes',
        statusID: searchForm.statusID || '',
        advanceRequestType: searchForm.advanceRequestType || '',
        startDate: startDate,
        endDate: endDate,
      });
    }
  }

  async function createDataForExcel(array) {
    var res = [];
    const sourceLookup = {
      1: 'Mobile Advance',
      2: 'Over Advance',
      3: 'Direct Advance'
    };

    const statusLookup = {
      1: 'Pending',
      2: 'Issue',
      3: 'Reject',
      4: 'Send_To_Deliver',
      5: 'Authorized',
      6: 'Delivered'
    };
    if (array != null) {
      array.map(x => {
        var vr = {
          'Date': x.effectiveDate.split('T')[0],
          'Date': x.Issuingdate.split('T')[0],
          'Route Name': x.routeName,
          'Registration Number': x.registrationNumber,
          'Source': sourceLookup[x.advanceRequestType] || x.advanceRequestType,
          'Status': statusLookup[x.statusID] || x.statusID,
          'Requested Amount(Rs)': x.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Approved Amount(Rs)': x.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Amout': x.totalapproveAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        }
        res.push(vr);
      });
    }
    return res;
  }

  async function createDataForExcel(array) {
    var result = [];
    if (array != null) {
      array.forEach(x => {
        result.push({
          CreatedDate: x.effectiveDate.split('T')[0],
          IssuingDate: x.issuingDate.split('T')[0],
          routeName: x.routeName,
          registrationNumber: x.registrationNumber,
          Source: x.advanceRequestType == 1 ? 'Mobile Advance' : x.advanceRequestType == 2 ? 'Over Advance' : x.advanceRequestType == 3 ? 'Direct Advance' : '-',
          Status: x.statusID == 1 ? 'Pending' : x.statusID == 2 ? 'Issue' : x.statusID == 3 ? 'Reject' : x.statusID == 4 ? 'Send_To_Deliver' : x.statusID == 5 ? 'Authorized' : x.statusID == 5 ? 'Delivered' : '-',
          'RequestedAmount (Rs)': x.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'ApprovedAmount (Rs)': x.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        });
      }
      );
      result.push({
      });

      result.push({
        IssuingDate: 'Factory : ' + selectedSearchValues.factoryName,
        CreatedDate: 'Group : ' + selectedSearchValues.groupName,
      });
      result.push({
        IssuingDate: 'To Date : ' + selectedSearchValues.endDate,
        CreatedDate: 'From Date : ' + selectedSearchValues.startDate,
      });
      result.push({
        IssuingDate: 'Source :' + (selectedSearchValues.advanceRequestType === 1 ? 'Mobile Advance' : selectedSearchValues.advanceRequestType === 2 ? 'Over Advance' : selectedSearchValues.advanceRequestType === 3 ? 'Direct Advance' : 'All Source'),
        CreatedDate: 'Status : ' + (selectedSearchValues.statusID == 1 ? 'Pending' : selectedSearchValues.statusID == 2 ? 'Issue' : selectedSearchValues.statusID == 3 ? 'Reject' : selectedSearchValues.statusID == 4 ? 'Send_To_Deliver' : selectedSearchValues.statusID == 5 ? 'Authorized' : selectedSearchValues.statusID == 5 ? 'Delivered' : 'All Status'),

      });
      result.push({
        CreatedDate: 'routeName : ' + (selectedSearchValues.routeName === undefined ? 'ALL Routes' : selectedSearchValues.routeName),
      });

    }
    return result;
  }

  async function createFile() {
    var file = await createDataForExcel(advancePaymentData);
    var settings = {
      sheetName: 'Remove Advance Payment',
      fileName: 'Remove Advance Payment' + ' ' + selectedSearchValues.groupName + ' ' + selectedSearchValues.factoryName,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);

    let tempcsvHeaders = [];
    keys.forEach(sitem => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    SetCsvHeaders(tempcsvHeaders);

    let dataA = [
      {
        sheet: 'Remove Advance Payment',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setAdvancedPaymentList({
      ...advancedPaymentList,
      [e.target.name]: value
    });
    setHiddenTable(true);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  async function handleDateChange(e) {
    setHiddenTable(true); 
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: advancedPaymentList.groupID,
              factoryID: advancedPaymentList.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={advancedPaymentList.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={advancedPaymentList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="fromDate" style={{ marginBottom: '-8px' }}>
                              From Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="fromDate"
                                value={fromDate}
                                onChange={(e) => {
                                  handleFromDate(e);
                                  handleDateChange(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="toDate" style={{ marginBottom: '-8px' }}>
                              To Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="toDate"
                                value={toDate}
                                onChange={(e) => {
                                  handleToDate(e);
                                  handleDateChange(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              size='small'
                              onChange={(e) => handleChange(e)}
                              value={advancedPaymentList.routeID}
                              variant="outlined"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="advanceRequestType">
                              Source
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="advanceRequestType"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={advancedPaymentList.advanceRequestType}
                              variant="outlined"
                              id="advanceRequestType"
                            >
                              <MenuItem value={'0'}>--Select Source--</MenuItem>
                              <MenuItem value={'1'}>Mobile Advance</MenuItem>
                              <MenuItem value={'2'}>Over Advance</MenuItem>
                              <MenuItem value={'3'}>Direct Advance</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="statusID">
                              Status
                            </InputLabel>

                            <TextField select
                              fullWidth
                              name="statusID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={advancedPaymentList.statusID}
                              variant="outlined"
                              id="statusID"
                            >
                              <MenuItem value={'0'}>--Select Status--</MenuItem>
                              <MenuItem value={'1'}>Pending</MenuItem>
                              <MenuItem value={'2'}>Issued</MenuItem>
                              <MenuItem value={'3'}>Rejected</MenuItem>
                              <MenuItem value={'4'}>Delivered</MenuItem>
                              <MenuItem value={'5'}>Authorized</MenuItem>
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050} hidden={hiddenTable}>

                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            { title: 'Created Date', field: 'effectiveDate', render: rowData => rowData.effectiveDate.split('T')[0] },
                            { title: 'Issuing Date', field: 'issuingDate', render: rowData => rowData.issuingDate.split('T')[0] },
                            { title: 'Route Name', field: 'routeName' },
                            { title: 'Registration Number', field: 'registrationNumber' },
                            { 
                              title: 'Requested Amount(Rs)', 
                              field: 'amount', 
                              render: rowData => rowData.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                              headerStyle: { textAlign: "right"},
                              cellStyle: { textAlign: "right", paddingRight:'3%' }, 
                            },
                            { title: 'Approved Amount(Rs)', 
                              field: 'approvedAmount', 
                              render: rowData => rowData.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                              headerStyle: { textAlign: "right"},
                              cellStyle: { textAlign: "right", paddingRight:'3%' },  
                            },
                            {
                              title: 'Source', field: 'advanceRequestType', lookup: {
                                1: 'Mobile Advance',
                                2: 'Over Advance',
                                3: 'Direct Advance'
                              }
                            },
                            {
                              title: 'Status', field: 'statusID', lookup: {
                                1: 'Pending',
                                2: 'Issue',
                                3: 'Reject',
                                4: 'Send_To_Deliver',
                                5: 'Authorized',
                                6: 'Delivered'
                              }
                            },
                            {
                              title: 'PDF', field: 'button',
                              render: (rowData) => {
                                componentRef.current[rowData.index] = componentRef.current[rowData.index]
                                return (
                                  <>
                                    <ReactToPrint
                                      documentTitle={`Main Cash Payment Voucher - Reg No. ${rowData.registrationNumber}`}
                                      trigger={() => (
                                        <Tooltip title="PDF">
                                          <IconButton
                                            aria-label="PDF"
                                          >
                                            <PictureAsPdfIcon style={{ color: 'red' }} />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                      content={() => componentRef.current[rowData.index]}
                                    />
                                    <div hidden={true}>
                                      <PaymentVoucherPDF
                                        ref={(el) => (componentRef.current[rowData.index] = el)}
                                        voucherData={rowData}
                                        searchData={selectedSearchValues}
                                      />
                                    </div>
                                  </>
                                )
                              }
                            }
                          ]}

                          data={advancePaymentData}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1,
                            pageSize: 10,
                            initialPage: page,
                          }}
                          actions={[{
                            icon: VisibilityIcon,
                            tooltip: 'View',
                            onClick: (event, rowData) => handleClickView(rowData.advancePaymentRequestID, rowData.issuingDate, rowData.routeName)

                          },

                          rowData => ({
                            icon: 'delete',
                            tooltip: 'Delete',
                            onClick: (event, oldData) => {
                              setDeletingRow(oldData);
                              setDeleteConfirmationOpen(true);
                            },
                            disabled: rowData.executionStatusID === 3,
                          }),
                          ]}
                          onChangePage={page => setPage(page)}
                        />
                        <Dialog
                          open={deleteConfirmationOpen}
                          onClose={handleDeleteConfirmationClose}
                        >
                          <DialogTitle id="alert-dialog-slide-title">
                            {' '}
                            <Typography color="textSecondary" gutterBottom variant="h3">
                              <Box textAlign="center">{'Delete Advanced Payment Detail'}</Box>
                            </Typography>
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              {'Are you sure you want to delete the record for Registration Number ' +
                                deletingRow?.registrationNumber +
                                ' with Requested Amount ' +
                                deletingRow?.amount.toFixed(2) +
                                ' Rs?'}
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={handleDeleteConfirmationClose}
                              color="primary"
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                DeleteAdvancePaymentDetail();
                                const data = [...state];
                                data.splice(data.indexOf(deletingRow), 1);
                                setState(data);
                                handleDeleteConfirmationClose();
                              }}
                              variant="contained"
                              color="secondary"
                              className={classes.button}
                              startIcon={<DeleteIcon />}
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Box display="flex" justifyContent="flex-end" p={2} hidden={hiddenTable}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={`Remove Advance Payment ${selectedSearchValues.groupName} ${selectedSearchValues.factoryName}`}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              advancedPaymentList={advancePaymentData} searchData={selectedSearchValues}
                            />
                          </div>
                        </Box>
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}

